import { TextField, Typography } from "@mui/material";
import pageTextConfig from '../../../../assets/configs/Add New Gig Page/PaymentSetupPage/textConfig';

const BankAccountFormControl = ({paymentFormData, updateBankAccountDetails}: any) => {
    return (
      <>
        <Typography sx={{ marginBottom: '15px' }}
          variant='body1'>
          {pageTextConfig.enterBankAccountDetailsprompt}
        </Typography>
  
        <TextField
          className="textFields"
          required
          value={paymentFormData.bankAccountDetails.bankName}
          name='bankName'
          id="outlined-number"
          type={'text'}
          label="Enter Bank Name"
          InputProps={{ style: { fontFamily: "Arial" } }}
          sx={{ width: '70%', marginBottom: '15px' }}
          onChange={updateBankAccountDetails} />
  
        <TextField
          className="textFields"
          required
          id="outlined-number"
          type={'text'}
          label="Enter Account Holder Name"
          InputProps={{ style: { fontFamily: "Arial" } }}
          sx={{ width: '70%', marginBottom: '15px' }}
          name='holderName'
          inputProps={{ maxLength: 50 }}
          value={paymentFormData.bankAccountDetails.holderName}
          onChange={updateBankAccountDetails} />
  
        <TextField
          className="textFields"
          required
          type={'text'}
          label="Enter Bank Account Number"
          onChange={(event) => {
            event.target.value = event.target.value.replace(/[^\d]+/, '')
            updateBankAccountDetails(event)
          }}
          InputProps={{ style: { fontFamily: "Arial" } }}
          sx={{ width: '70%', marginBottom: '15px' }}
          name='accountNumber'
          inputProps={{ maxLength: 18 }}
          value={paymentFormData.bankAccountDetails.accountNumber} />
  
        <TextField
          className="textFields"
          required
          type={'text'}
          label="Enter Bank IFSC Code"
          InputProps={{ style: { fontFamily: "Arial" } }}
          sx={{ width: '70%', marginBottom: '15px' }}
          name='bankIFSC'
          inputProps={{ maxLength: 11 }}
          value={paymentFormData.bankAccountDetails.bankIFSC}
          onChange={updateBankAccountDetails} />
      </>
    )
  }

  export default BankAccountFormControl;